import React from "react";
import { Link } from "react-router-dom";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="vitri-loading-container">
      <Link to="/">
        <img
          src="images/vitri-blue-logo.png"
          alt="VITRI ENTERPRISES Logo"
          className="loading-logo"
        />
      </Link>
    </div>
  );
};

export default Loader;
